import { render } from "./PwdInput.vue?vue&type=template&id=18ce82a4&scoped=true"
import script from "./PwdInput.vue?vue&type=script&lang=js"
export * from "./PwdInput.vue?vue&type=script&lang=js"

import "./PwdInput.vue?vue&type=style&index=0&id=18ce82a4&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ce82a4"]])

export default __exports__